import { Controller } from "@hotwired/stimulus"
import Pagy from '../vendor/pagy.mjs'

// https://ddnexus.github.io/pagy/resources/javascript/
// The helpers and paginators suffixed with *_js require JavaScript support.
export default class extends Controller {
  connect () {
    Pagy.init()
  }
}
